import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import StudentProfileHeader from "./StudentProfileHeader";
import StudentProfileInformation from "./StudentProfileInformation";
import StudentLearningInformation from "./StudentLearningInformation";
import StudentUpcomingSessions from "./StudentUpcomingSessions";
import StudentEnrolledCourses from "./StudentEnrolledCourses";

const formatStudentDisplayId = (studentId) => {
  if (!studentId) {
    return "-";
  }

  const idSuffix = String(studentId).slice(-3).toUpperCase();
  return `ID-STD-${idSuffix}`;
};

const StudentProfileView = () => {
  const navigate = useNavigate();
  const { studentId } = useParams();
  const { state } = useLocation();
  const student = state?.student;

  const studentName = student?.name || "John Doe";
  const studentStatus = student?.status || "Active";
  const studentLevel = student?.level || "Advanced";
  const studentEmail = student?.email || "johndoe23@gmail.com";
  const studentCourse = Array.isArray(student?.course)
    ? student.course[0] || "Mental Maths"
    : student?.course || "Mental Maths";

  const handleViewProgress = () => {
    navigate(`/admin/student-progress/student-overview/${studentId}`, {
      state: {
        student: {
          studentId,
          id: studentId,
          name: studentName,
          email: studentEmail,
          course: studentCourse,
        },
      },
    });
  };

  return (
    <section className="min-h-screen bg-white px-5 xl:px-6 2xl:pl-9 2xl:pr-6 pb-10 pt-4 font-['Roboto']">
      <StudentProfileHeader
        title="Student Profile"
        name={studentName}
        displayId={formatStudentDisplayId(studentId)}
        status={studentStatus}
        level={studentLevel}
        profilePicture={student?.profilePicture}
        onBack={() => navigate(-1)}
        actionLabel="View Progress"
        onAction={handleViewProgress}
      />

      <div className="mt-4 grid  grid-cols-1  gap-[38px] lg:grid-cols-2">
        <div className="space-y-[38px]">
          <StudentProfileInformation
            email={studentEmail}
            course={studentCourse}
            level={studentLevel}
          />
          <StudentUpcomingSessions courseName={studentCourse} />
        </div>
        <div className="space-y-[38px]">

          <StudentLearningInformation />
          <StudentEnrolledCourses />
        </div>
      </div>
    </section>
  );
};

export default StudentProfileView;
